<template>
  <div class="game-list">
    <div>
      <h1 class="text-capitalize-first">{{$t('games')}}</h1>
    </div>

    <div class="games-wrapper">
      <game-icon @favorite-changed="onFavoriteChange" v-for="(game, index) in state.games.items" :key="game.id" :game="game"></game-icon>
    </div>
  </div>
</template>
<style scoped>
.game-list {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
}
.games-wrapper {
  margin-left: 0;
  margin-right: 0;
}
</style>
<script lang="ts" setup>
import GameIcon from "@/components/games/GameIcon.vue";
import {reactive} from "@vue/reactivity";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import GameDTO from "@/models/GameDTO";
import {onMounted} from "vue";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";

const state = reactive({
  games: {
    limit: 100,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<GameDTO>,
});
const store = useStore();

const onFavoriteChange = (game: GameDTO) => {
  if (game.isFavorite) {
    store.dispatch('addFavoriteGame', game);
  } else {
    store.dispatch('removeFavoriteGame', game);
  }

  const item = state.games.items.find(g => g.id === game.id);
  if (item) {
    item.isFavorite = game.isFavorite
  }
}

onMounted(async () => {
  [state.games] = await Promise.all([
    api.call.games.list(state.games),
  ])
})
</script>
